import { useState, useCallback } from "react";

const useToggle = (initialValue: boolean = false) => {
  const [value, setInnerValue] = useState(initialValue);

  const toggle = useCallback(() => setInnerValue((prev) => !prev), []);
  const setTrue = useCallback(() => setInnerValue(true), []);
  const setFalse = useCallback(() => setInnerValue(false), []);
  const setValue = useCallback((val: boolean) => setInnerValue(val), []);

  return { value, toggle, setTrue, setFalse, setValue };
};

export default useToggle;
